import { Component, AfterViewInit, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from "ngx-spinner";
import { AlertboxComponent } from '../alertbox/alertbox.component'
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { DatePipe } from '@angular/common';
import { element } from 'protractor';
import { HttpErrorResponse } from '@angular/common/http';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
@Component({
  selector: 'app-reservations-details',
  templateUrl: './reservations-details.component.html',
  styleUrls: ['./reservations-details.component.scss']
})
export class ReservationsDetailsComponent implements OnInit, AfterViewInit {
  @Output() next = new EventEmitter<void>();
  @Input() tabName: string = '';
  // @Output() prev = new EventEmitter<void>(); 
  @Output() prev = new EventEmitter<boolean>();
  @Output() first = new EventEmitter<void>();
  dialogRef: MatDialogRef<any>;
  message1: any;
  minorityList: any;
  filteredMinorityList: any;
  categoryList: any;
  filteredCategoryList: any;
  religionList: any;
  filteredReligionList: any;
  specialAbledList: any;
  disabled = false;
  filteredspecialAbledList: any;
  orphanTypeList: any;
  filteredorphanTypeList: any;
  ConstiCateList: any;
  filteredConstiCateList: any;
  SRList: any;
  filteredSR: any;
  isStuCasteDisable = false
  isStuCasteCertDisable = false
  isStuCasteValCertDisable = false;
  isStuNonCrmValDtDisable = false;
  isStuNonCrmValDtDisable2 = false;
  isStuOrphanTypeDisable = false;
  isStuSpecialAbledTypeDisable = false;
  isStuMinorityTypeDisable = false;
  isStuNonCrmCertDisable = false
  isStuMinorityType2Disable = false;
  isStuInHouseDisable = false;
  isStuMinorityDisable = false;
  Course: any;
  College: any;
  tabs : string;
  displayName : any;
  isSaving: boolean = false;
  SnNo: any;
  constructor(private fb: FormBuilder, public umsService: UmsService, private router: Router,
    private modalPopupService: ModalpopService, public datepipe: DatePipe,
    private spinner: NgxSpinnerService) { }
  reservationsDetailsFormArray;
  reservationsDetailsForm: FormGroup;
  submitButton = true;
  updateButton = false;
  currentdate: any;
  isDisabled = false;
  isDisabledOP = false;
  isminorityDisable = false;
  disableMinority = true;
  isDisabledNoncremeLayer = false;
  isDisabledCastCerti = false;
  isDisabledCastGene = false;
  message: any
  valueForMakeReq: any;
  valueForMakeReq1: any;
  delReadOnly = false;
  session = sessionStorage.getItem('session');
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    ReservationShow = false;
    calledApi = 0; // Total number of APIs called
    finishedApi = 0; // Total number of APIs completed (success or failure)
  
  ngOnInit(): void {
    this.ReservationShow = false;
    this.delReadOnly = false;
    this.currentdate = new Date();
    this.submitButton = true;
    this.updateButton = false;
    this.isDisabled = false;
    this.isDisabledOP = false;
    this.isminorityDisable = false;
    this.disableMinority = true;
    this.isDisabledNoncremeLayer = false;
    this.isDisabledCastCerti = false;
    this.isDisabledCastGene = false;
    this.disabled = false;
    this.isStuCasteDisable = false
    this.isStuCasteCertDisable = false
    this.isStuInHouseDisable = false
    this.isStuNonCrmCertDisable = false
    this.isStuMinorityDisable = false
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.session = sessionStorage.getItem('session');
    this.reservationsDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuResId: new FormControl(''),
    });

    // this.reservationsDetailsForm.controls['StuCasteCert'].setValue(2);
    this.spinner.show();
    this.getSecretData();
    this.fetchReligion();
    this.fetchSpAbled();
    this.fetchorphanType();
    this.fetchConstiCate();
    this.fetchSocialReservation();
    // this.getScrutiny();
    this.getApplyData();
    this.prepopulationContact();
    this.prepopulation();
  }

  ngAfterViewInit(): void {
    // this.loadsettingspage(); 
   // this.prepopulation();
  }

  
    getSecretData() {
        this.calledApi++;
        let payload = {};
        this.umsService.getSecretData().subscribe((res) => {
          if(res.status){
            this.SnNo = res.projectPharam['SnNo'];
            this.finishedApi++;
            if (this.finishedApi === this.calledApi) {
              this.spinner.hide();
            };
          }
          else{
            this.finishedApi++;
            if (this.finishedApi === this.calledApi) {
              this.spinner.hide();
            };
          }
        },(ERROR:HttpErrorResponse) => {
          this.finishedApi++;
          if (this.finishedApi === this.calledApi) {
            this.spinner.hide();
          };
        });
      }
    
       getFeeStatus(StuId){
        const payload = {};
        payload['StuId'] = StuId;
        payload['SnNo'] = this.session;
        this.umsService.getFeeStatus(payload).subscribe(res => {
          if(res.status){
            console.log('fees status response i get is',res.data);
            this.getScrutiny(StuId)
          }
          else{
            this.disabled = false;
          }
        },(ERROR:HttpErrorResponse) => {
          this.disabled = false;
        })
       }

  getScrutiny(StuId) {
    this.calledApi++; // Increment the called API count
    const payload = {};
    payload['StudentId'] = StuId
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      this.tabs = res.data[0].Tabs;
       if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
        this.spinner.hide();
        if(res.data[0].Tabs.includes('Reservations Details')){
          this.disabled = false;
        }else{
          this.disabled = true;
        }
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else { 
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.disabled = true;
      }
    },(ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
    });
  }

  prepopulation() {
    let payload = {}; 
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchReservationDetails(payload).subscribe(async (res) => {
      if (res.status) { 
        if (res.data.length > 0) {
          res.data[0].StuCaste = parseInt(res.data[0].StuCaste);
          // res.data[0].StuConstiSubCate =parseInt(res.data[0].StuConstiSubCate);
        await  this.fetchMinorityType(res.data[0].StuMinorityType);
        await this.fetchConstiCate()
        await this.fetchCast(res.data[0].StuConstiSubCate);
        await  this.onSelectionCastCertificat2(res.data[0].StuCasteCert)
        await  this.fetchorphanType()
        await  this.fetchSpAbled();
        await  this.StuMinorityTypeDisable2(res.data[0])
        await  this.StuOrphanTypeDisable2(parseInt(res.data[0].StuOrphan));
        await  this.StuSpecialAbledTypeDisable2(parseInt(res.data[0].StuPhyHand));
        await this.getFeeStatus(res.data[0].StuId)
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          this.updateButton = true;
          this.submitButton = false;
         await this.prepopulatedatapage(res);
          let e = ''
        } else {
          await this.loadsettingspage();
        }
      } else {
       
        await this.loadsettingspage();
      }

    },(ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })

  }

  prepopulation2() {
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchReservationDetails(payload).subscribe((res) => {
      if (res.status) {
        if (res.data.length > 0) {
           this.umsService.disable3 = false;
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          // this.updateButton = true;
          // this.submitButton = false;
          // this.prepopulatedatapage(res);
          let e = ''
        } else {
          // this.loadsettingspage();
          this.umsService.disable3 = true;
        }
      } else {
        this.loadsettingspage();
      }

    })

  }
  StuOrphanTypeDisable2(e) {
    if (e == 1) {
      this.isStuOrphanTypeDisable = false
    }
    else if (e == 2) {
      this.isStuOrphanTypeDisable = true
    }
  }

  StuSpecialAbledTypeDisable2(e) {
    if (e == 1) {
      this.isStuSpecialAbledTypeDisable = false
    }
    else if (e == 0) {
      this.isStuSpecialAbledTypeDisable = true
    }
  }

  prepopulatedatapage(e) {
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.reservationsDetailsForm.controls['StuResId'].setValue(e.data[0]['StuResId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.valueForMakeReq1 = ress.data;
      ress.data.forEach((element) => {
        if (element.FormVisible) {

          if (element.FormRequired) {
            this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));
          } else {
            if (element.FormPattern == '') {
              this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
            }
            else {
              this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.pattern(element.FormPattern)]));
            }
          }

        } else {
          this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.reservationsDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ReservationShow = true;
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }




  fetchSocialReservation() {
    this.calledApi++; // Increment the called API count
    const payload = {};
    payload['CdType'] = 'SR';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.SRList = res.data;
        this.filteredSR = this.SRList.slice();
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      } else {
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
    });
  }
 
  loadsettingspage() {
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.valueForMakeReq = res.data;
      res.data.forEach((element) => {
        if (element.FormVisible) {

          if (element.FormRequired) {
            this.reservationsDetailsForm.addControl(
              element.FormControlName,
              new FormControl('', Validators.required)
            );
          } else {
            if (element.FormPattern == '') {
              this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(''));
            } else {
              this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
            }
          }
        }
      });
      this.reservationsDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ReservationShow = true;
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  SubmitFormarkAsTouched() {
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            const control = this.reservationsDetailsForm.get(element.FormControlName);
            if (control) {
              control.markAsTouched();
              if (element.FormControlName == "StuMinority" && this.isStuMinorityDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuMinorityType" && this.isStuMinorityTypeDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuMinorityType2" && this.isStuMinorityType2Disable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuCaste" && this.isStuCasteDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuCasteCert" && this.isStuCasteCertDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuCasteValCert" && this.isStuCasteValCertDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuNonCrmCert" && this.isStuNonCrmCertDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuNonCrmValDt" && this.isStuNonCrmValDtDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuInHouse" && this.isStuInHouseDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuSpecialAbledType" && this.isStuSpecialAbledTypeDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuOrphanType" && this.isStuOrphanTypeDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              return
            }

          }
        }
      });
      this.reservationsDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ReservationShow = true;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

    this.finalsubmit();
  }

  updateFormarkAsTouched() {
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            const control = this.reservationsDetailsForm.get(element.FormControlName);
            if (control) {
              control.markAsTouched();
              if (element.FormControlName == "StuMinority" && this.isStuMinorityDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuMinorityType" && this.isStuMinorityTypeDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuMinorityType2" && this.isStuMinorityType2Disable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuCaste" && this.isStuCasteDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuCasteCert" && this.isStuCasteCertDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuCasteValCert" && this.isStuCasteValCertDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuNonCrmCert" && this.isStuNonCrmCertDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuNonCrmValDt" && this.isStuNonCrmValDtDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuInHouse" && this.isStuInHouseDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuSpecialAbledType" && this.isStuSpecialAbledTypeDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              else if (element.FormControlName == "StuOrphanType" && this.isStuOrphanTypeDisable == true) {
                const control = this.reservationsDetailsForm.get(element.FormControlName);
                control.clearValidators();
                control.updateValueAndValidity();
              }
              return
            }

          }
        }
      });
      this.reservationsDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ReservationShow = true;
    });

    this.finalupdtae();
  }

  submitReservationDetails() {
    if (this.reservationsDetailsForm.invalid) {
      this.SubmitFormarkAsTouched();
    } else {
      this.finalsubmit()
    }
  }

  finalsubmit() {
    this.isSaving = true;
    this.spinner.show();
    let payload = this.reservationsDetailsForm.value;
    let da = this.reservationsDetailsForm.value.StuNonCrmValDt;
    payload['StuNonCrmValDt'] = this.datepipe.transform(da, 'yyyy-MM-dd');
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
    // this.reservationsDetailsForm.controls['StuSocialRes'].setValue('NA')
    
    this.umsService.addReservationDetails(payload).subscribe(res => {
      if(res.status){ 
        this.isSaving = false;
        this.spinner.hide();
        let data = {}
       data['message'] = res.message
       data['title'] = 'Information'
       data['icon'] = 'fas fa-check'
       this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
       this.next.emit();
  
      }
      else{
        this.spinner.hide();
        this.isSaving = false;
      }
         
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.isSaving = false;
    });
  }

  updateReservationDetails() {
    if (this.reservationsDetailsForm.invalid) {
      this.updateFormarkAsTouched();

    } else {
      this.finalupdtae();
    }
  }

  // getTabName(e){
  //   this.displayName = e;
  // }
  getTabDisplayName(): string {
    return `Current Tab: ${this.tabName}`;
  }

  finalupdtae() {
    this.UpdateScrutiny();
  }

  UpdateScrutiny(){
    this.isSaving = true;
    this.spinner.show();
   let payload = this.reservationsDetailsForm.value;
    let da = this.reservationsDetailsForm.value.StuNonCrmValDt;
    payload['StuNonCrmValDt'] = this.datepipe.transform(da, 'yyyy-MM-dd');
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
    // this.reservationsDetailsForm.controls['StuSocialRes'].setValue('NA')
    console.log('payload',payload)
    this.umsService.updateReservationDetails(payload).subscribe(res => {
    if(res.status){
    this.umsService.setTabSaved('reservationTab');
  const canUpdateScrutiny =
  this.tabs &&
  this.umsService.isRequiredTabsSaved(this.tabs);
  if (canUpdateScrutiny) {

  const data = {};
  data['message'] =
    'Are You Sure You Have Updated ' +
    this.tabs +
    ' Tabs. Do You Want To Proceed?';

  data['title'] = 'Alert';
  data['icon'] = 'fa fa-question';

  this.dialogRef =
    this.modalPopupService.openPopup<ConformationModelComponent>(
      ConformationModelComponent,
      data
    );

  this.dialogRef.afterClosed().subscribe(result => {
    if (result === 'yes') {
      this.UpdScrtDetails();
        if (this.tabs?.includes('Wrong Payment')) {
      this.router.navigate(['/Fees']);
      }
    }
  });
}
      this.isSaving = false;
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.next.emit();
    }
    else{
      this.isSaving = false;
      this.spinner.hide();
    }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.isSaving = false;
    }
    );
  }
  back() {
    this.prev.emit(false);
  }
 
  fetchCast(value) {
    if (value == 'GM') {
      this.isStuCasteDisable = true
      this.isStuCasteCertDisable = true
      this.isStuCasteValCertDisable = true
      this.isStuNonCrmCertDisable = true
      this.isStuNonCrmValDtDisable = true
      this.isStuInHouseDisable = true
      this.isStuMinorityDisable = true
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
    }
    else {
      this.isStuCasteDisable = false;
      this.isStuCasteCertDisable = false;
      this.isStuCasteValCertDisable = false;
      this.isStuNonCrmCertDisable = false;
      this.isStuNonCrmValDtDisable = false;
      this.isStuInHouseDisable = false;
      this.isStuMinorityDisable = false;
      this.isStuMinorityTypeDisable = false;
      this.isStuMinorityType2Disable = false;
      
      this.spinner.show()
      const payload = {};
      this.categoryList = [];
      this.filteredCategoryList = [];
      payload['CategoryId'] = value;
      this.umsService.fetchCategory(payload).subscribe((res) => {
        if (res.status) {
          this.spinner.hide();
          this.categoryList = res.data;
          this.filteredCategoryList = this.categoryList.slice();
          //this.castGene(payload)
        }
        else {
        this.spinner.hide();
        }

      }, (ERROR: HttpErrorResponse) => {
    
        this.spinner.hide();
      });
    }


  }

  fetchCast2(value) {
    if (value == 'GM') {
      this.isStuCasteDisable = true
      this.isStuCasteCertDisable = true
      this.isStuCasteValCertDisable = true
      this.isStuNonCrmCertDisable = true
      this.isStuNonCrmValDtDisable = true
      this.isStuInHouseDisable = true
      this.isStuMinorityDisable = true
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
      this.reservationsDetailsForm.get('StuCaste').patchValue('');

      this.reservationsDetailsForm.get('StuCaste').markAsUntouched();
      this.reservationsDetailsForm.get('StuCasteCert').patchValue(2);
      this.reservationsDetailsForm.get('StuCasteValCert').patchValue(3);
      this.reservationsDetailsForm.get('StuNonCrmCert').patchValue(2);
      this.reservationsDetailsForm.get('StuNonCrmValDt').patchValue('');
      this.reservationsDetailsForm.get('StuInHouse').patchValue(2);
      this.reservationsDetailsForm.get('StuMinority').patchValue(2);
      this.reservationsDetailsForm.get('StuMinorityType').patchValue(3);
      this.reservationsDetailsForm.get('StuMinorityType2').patchValue('');

      this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
      this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();
      this.reservationsDetailsForm.get('StuCaste').markAsUntouched();
    }
    else {
      this.isStuCasteDisable = false;
      this.isStuCasteCertDisable = false;
      this.isStuCasteValCertDisable = false;
      this.isStuNonCrmCertDisable = false;
      this.isStuNonCrmValDtDisable = false;
      this.isStuInHouseDisable = false;
      this.isStuMinorityDisable = false;
      this.isStuMinorityTypeDisable = false;
      this.isStuMinorityType2Disable = false;

      this.reservationsDetailsForm.get('StuCaste').patchValue('');
      this.reservationsDetailsForm.get('StuCaste').markAsUntouched();

      this.reservationsDetailsForm.get('StuCasteCert').patchValue('');
      this.reservationsDetailsForm.get('StuCasteCert').markAsUntouched();

      this.reservationsDetailsForm.get('StuCasteValCert').patchValue('');
      this.reservationsDetailsForm.get('StuCasteValCert').markAsUntouched();

      this.reservationsDetailsForm.get('StuNonCrmCert').patchValue('');
      this.reservationsDetailsForm.get('StuNonCrmCert').markAsUntouched();

      this.reservationsDetailsForm.get('StuNonCrmValDt').patchValue('');
      this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();

      this.reservationsDetailsForm.get('StuInHouse').patchValue('');
      this.reservationsDetailsForm.get('StuInHouse').markAsUntouched();

      this.reservationsDetailsForm.get('StuMinority').patchValue('');
      this.reservationsDetailsForm.get('StuMinority').markAsUntouched();

      this.reservationsDetailsForm.get('StuMinorityType').patchValue('');
      this.reservationsDetailsForm.get('StuMinorityType').markAsUntouched();

      this.reservationsDetailsForm.get('StuMinorityType2').patchValue('');
      this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
    }

    this.spinner.show()
    const payload = {};
    this.categoryList = [];
    this.filteredCategoryList = [];
    payload['CategoryId'] = value;
    this.umsService.fetchCategory(payload).subscribe((res) => {
      if (res.status) {
        this.categoryList = res.data;
        this.filteredCategoryList = this.categoryList.slice();
        this.spinner.hide();
      }
      else {
        this.spinner.hide();
      }

    }, (ERROR: HttpErrorResponse) => {
      let data = {}
      data['message'] = ERROR.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.spinner.hide();
    });
  }

  fetchReligion() {
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'Reg';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.religionList = res.data;
        this.filteredReligionList = this.religionList.slice();
      } else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
    
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchSpAbled() {
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'SpAb';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
        this.specialAbledList = res.data;
        this.filteredspecialAbledList = this.specialAbledList.slice();
      } else {
        this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchorphanType() {
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'Op';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
        this.orphanTypeList = res.data;
        this.filteredorphanTypeList = this.orphanTypeList.slice();
      } else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
    
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchMinorityType(value) {
    this.spinner.show();
    this.disableMinority = false;
    const payload = {};
    if (value === 1) {
      payload['MinorityType'] = 1;
      this.umsService.fetchMinority(payload).subscribe((res) => {
       
        if (res.status) {
          this.spinner.hide()
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        }
        else {
          this.spinner.hide()
        }
      });
    } else if (value === 2) {
      payload['MinorityType'] = 2;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        
        if (res.status) {
          this.spinner.hide()
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {
          this.spinner.hide()
        }
      });
    }
    else if (value === 3) {
      payload['MinorityType'] = 3;
      this.isStuMinorityType2Disable = true;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        
        if (res.status) {
          this.spinner.hide()
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {
          this.spinner.hide()
        }
      });
    }
    
  }



  fetchMinorityType2(value) {
    this.spinner.show();
    this.disableMinority = false;
    const payload = {};
    if (value === 1) {
      this.isStuMinorityType2Disable = false;
      payload['MinorityType'] = 1;
      this.umsService.fetchMinority(payload).subscribe((res) => {
       
        if (res.status) {
          this.spinner.hide()
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        }
        else {
          this.spinner.hide()
        }
      });
    } else if (value === 2) {
      this.isStuMinorityType2Disable = false;
      payload['MinorityType'] = 2;
      this.umsService.fetchMinority(payload).subscribe((res) => {
       
        if (res.status) {
          this.spinner.hide()
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {
          this.spinner.hide()
        }
      });
    }
    else {
      this.spinner.show()
      this.isStuMinorityType2Disable = true;
      this.reservationsDetailsForm.get('StuMinorityType2').patchValue('');
      this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
      payload['MinorityType'] = 3;
      this.umsService.fetchMinority(payload).subscribe((res) => {
       
        if (res.status) {
          this.spinner.hide()
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {
          this.spinner.hide()
        }
      });
    }
  }

  fetchConstiCate() {
    this.calledApi++; // Increment the called API count
    const payload = {};
    payload['CdType'] = 'CS';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.ConstiCateList = res.data;
        this.filteredConstiCateList = this.ConstiCateList.slice();
      } else {
        this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
      }
    });
  }

  onSelectionCastCertificat(e) {
    if (e === '1') {
      this.isStuCasteValCertDisable = false;
      this.isStuNonCrmValDtDisable = false;
      this.isStuNonCrmValDtDisable2 = false
      this.reservationsDetailsForm.controls['StuCasteValCert'].setValue('')
      this.reservationsDetailsForm.controls['StuNonCrmCert'].setValue('')
      this.reservationsDetailsForm.get('StuCasteValCert').markAsUntouched();
      this.reservationsDetailsForm.get('StuNonCrmCert').markAsUntouched();
    } else {
      this.isStuCasteValCertDisable = true;
      this.isStuNonCrmValDtDisable = true;
      this.isStuNonCrmValDtDisable2 = true
      
      this.reservationsDetailsForm.controls['StuCasteValCert'].setValue(2)
      this.reservationsDetailsForm.controls['StuNonCrmValDt'].setErrors(null);
    this.reservationsDetailsForm.controls['StuNonCrmValDt'].clearValidators();
    this.reservationsDetailsForm.controls['StuNonCrmValDt'].updateValueAndValidity();
      this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();
      this.reservationsDetailsForm.controls['StuNonCrmValDt'].setValue('')
      this.reservationsDetailsForm.controls['StuNonCrmCert'].setValue(2)
    }
  }

  onSelectionCastCertificat2(e) {
    if (e == '2') {
      this.isStuCasteValCertDisable = true;
      this.isStuNonCrmValDtDisable = true;
      this.isStuNonCrmValDtDisable2 = true
       } 
   
  }

  StuNonCrmValDtDisable(e) {
    if (e === '1' || e === 1) {
      this.isStuNonCrmValDtDisable = false
    } else {
      this.reservationsDetailsForm.controls['StuNonCrmValDt'].setErrors(null);
    this.reservationsDetailsForm.controls['StuNonCrmValDt'].clearValidators();
    this.reservationsDetailsForm.controls['StuNonCrmValDt'].updateValueAndValidity();
      this.reservationsDetailsForm.get('StuNonCrmValDt').patchValue('');
      this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();
      this.isStuNonCrmValDtDisable = true
      // this.reservationsDetailsForm.controls['StuNonCrmValDt'].setValue(2)
    }
  }

  StuOrphanTypeDisable(e) {
    this.isStuOrphanTypeDisable = false
    if (e == 1) {
      this.isStuOrphanTypeDisable = false
      this.reservationsDetailsForm.controls['StuOrphanType'].setValue('')
    } else {
      this.isStuOrphanTypeDisable = true
      this.reservationsDetailsForm.controls['StuOrphanType'].setValue('NA')
    }
  }



  StuSpecialAbledTypeDisable(e) {
    this.isStuSpecialAbledTypeDisable = false
    if (e == 1) {

      this.isStuSpecialAbledTypeDisable = false
      this.reservationsDetailsForm.controls['StuSpecialAbledType'].setValue('')
    }

    else if (e == 0) {
      this.isStuSpecialAbledTypeDisable = true
      this.reservationsDetailsForm.controls['StuSpecialAbledType'].setValue('NA')
    }
  }



  StuMinorityTypeDisable(e) {
    if (e === 1) {
      this.isStuMinorityTypeDisable = false
      this.reservationsDetailsForm.controls['StuMinorityType'].setValue('')
       this.isStuMinorityType2Disable = false
      this.reservationsDetailsForm.controls['StuMinorityType2'].setValue('')
     } else {
      this.isStuMinorityTypeDisable = true
      this.reservationsDetailsForm.controls['StuMinorityType'].setValue(3)
      this.isStuMinorityType2Disable = true
      this.reservationsDetailsForm.controls['StuMinorityType2'].setValue(18)
    }
  }
  StuMinorityTypeDisable2(e) {
    if (e.StuMinority === 2 || e.StuMinority == 2) {
      this.isStuMinorityTypeDisable = true
       this.isStuMinorityType2Disable = true
     } else {
      this.isStuMinorityTypeDisable = false
      this.isStuMinorityType2Disable = false
      // this.reservationsDetailsForm.controls['StuMinorityType2'].setValue(18)
     
    }
  }



  markastouched() {
    if (this.reservationsDetailsForm.invalid) {
      this.reservationsDetailsForm.get('StuConstiCate').markAsTouched();
      this.reservationsDetailsForm.get('StuSocialRes').markAsTouched();
      this.reservationsDetailsForm.get('BPLCategory').markAsTouched();
      if (this.reservationsDetailsForm.get('StuNonCrmCert').value == '1') {
        this.reservationsDetailsForm.get('StuNonCrmValDt').markAsTouched();
      }
       else if(this.reservationsDetailsForm.get('StuNonCrmCert').value == '2') {
       
        this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();
        this.reservationsDetailsForm.controls['StuNonCrmValDt'].setErrors(null);
        this.reservationsDetailsForm.controls['StuNonCrmValDt'].clearValidators();
        this.reservationsDetailsForm.controls['StuNonCrmValDt'].updateValueAndValidity();
        this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();
      }
      if (this.reservationsDetailsForm.get('StuConstiSubCate').value == 'GM') {
        this.reservationsDetailsForm.controls['StuCaste'].setErrors(null);
    this.reservationsDetailsForm.controls['StuCaste'].clearValidators();
    this.reservationsDetailsForm.controls['StuCaste'].updateValueAndValidity();
    
    this.reservationsDetailsForm.controls['StuNonCrmValDt'].setErrors(null);
    this.reservationsDetailsForm.controls['StuNonCrmValDt'].clearValidators();
    this.reservationsDetailsForm.controls['StuNonCrmValDt'].updateValueAndValidity();

     this.reservationsDetailsForm.controls['StuMinorityType2'].setErrors(null);
    this.reservationsDetailsForm.controls['StuMinorityType2'].clearValidators();
    this.reservationsDetailsForm.controls['StuMinorityType2'].updateValueAndValidity();

    this.reservationsDetailsForm.get('StuCaste').markAsUntouched();
    this.reservationsDetailsForm.get('StuCasteCert').markAsUntouched();
    this.reservationsDetailsForm.get('StuCasteValCert').markAsUntouched();
    this.reservationsDetailsForm.get('StuNonCrmCert').markAsUntouched();
    this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();
    this.reservationsDetailsForm.get('StuInHouse').markAsUntouched();
    this.reservationsDetailsForm.get('StuMinority').markAsUntouched();
    this.reservationsDetailsForm.get('StuMinorityType').markAsUntouched();
    this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
    
      } else {
        this.reservationsDetailsForm.get('StuCaste').markAsTouched();
        this.reservationsDetailsForm.get('StuCasteCert').markAsTouched();
        this.reservationsDetailsForm.get('StuCasteValCert').markAsTouched();
        this.reservationsDetailsForm.get('StuNonCrmCert').markAsTouched();
        this.reservationsDetailsForm.get('StuNonCrmValDt').markAsTouched();
        this.reservationsDetailsForm.get('StuInHouse').markAsTouched();
        this.reservationsDetailsForm.get('StuMinority').markAsTouched();
        this.reservationsDetailsForm.get('StuMinorityType').markAsTouched();
        this.reservationsDetailsForm.get('StuMinorityType2').markAsTouched();
      }
      if (this.reservationsDetailsForm.get('StuCasteCert').value === '1') {
        this.reservationsDetailsForm.get('StuCasteValCert').markAsTouched();
        this.reservationsDetailsForm.get('StuNonCrmCert').markAsTouched();
           this.reservationsDetailsForm.get('StuCasteValCert').markAsTouched();
        this.reservationsDetailsForm.get('StuNonCrmCert').markAsTouched();
      } 
      
      else if(this.reservationsDetailsForm.get('StuCasteCert').value === '2') {
        this.reservationsDetailsForm.controls['StuCasteValCert'].setErrors(null);
        this.reservationsDetailsForm.controls['StuCasteValCert'].clearValidators();
        this.reservationsDetailsForm.controls['StuCasteValCert'].updateValueAndValidity();

       this.reservationsDetailsForm.controls['StuNonCrmValDt'].setErrors(null);
        this.reservationsDetailsForm.controls['StuNonCrmValDt'].clearValidators();
        this.reservationsDetailsForm.controls['StuNonCrmValDt'].updateValueAndValidity();
        this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();

        this.reservationsDetailsForm.controls['StuNonCrmCert'].setErrors(null);
        this.reservationsDetailsForm.controls['StuNonCrmCert'].clearValidators();
        this.reservationsDetailsForm.controls['StuNonCrmCert'].updateValueAndValidity();
        this.reservationsDetailsForm.get('StuCasteValCert').markAsUntouched();
        this.reservationsDetailsForm.get('StuNonCrmCert').markAsUntouched();
      }
      

      if (this.reservationsDetailsForm.get('StuMinority').value === '1') {
        this.reservationsDetailsForm.get('StuMinorityType').markAsTouched();
        this.reservationsDetailsForm.get('StuMinorityType2').markAsTouched();
      }
          if (this.reservationsDetailsForm.get('StuMinorityType').value === '1' ||
        this.reservationsDetailsForm.get('StuMinorityType').value === '2') {
        this.reservationsDetailsForm.get('StuMinorityType2').markAsTouched();
      }
    
      if (this.reservationsDetailsForm.get('StuPhyHand').value == 1) {

        this.reservationsDetailsForm.get('StuSpecialAbledType').markAsTouched();
      } 
   
      if (this.reservationsDetailsForm.get('StuOrphan').value == 1) {

        this.reservationsDetailsForm.get('StuOrphanType').markAsTouched();
      } 
         return
    }
    else{
      this.finalupdtae();
    }
  }


  markAsTouchedForSub(){
    if (this.reservationsDetailsForm.invalid) {
      this.reservationsDetailsForm.get('StuConstiSubCate').markAsTouched();
      this.reservationsDetailsForm.get('StuPhyHand').markAsTouched();
      this.reservationsDetailsForm.get('StuConstiCate').markAsTouched();
      this.reservationsDetailsForm.get('StuSocialRes').markAsTouched();
      this.reservationsDetailsForm.get('BPLCategory').markAsTouched();

      this.reservationsDetailsForm.get('StuOrphan').markAsTouched();

      if (this.reservationsDetailsForm.get('StuConstiSubCate').value == 'GM') {
        this.reservationsDetailsForm.controls['StuCaste'].setErrors(null);
    this.reservationsDetailsForm.controls['StuCaste'].clearValidators();
    this.reservationsDetailsForm.controls['StuCaste'].updateValueAndValidity();
    
    this.reservationsDetailsForm.controls['StuNonCrmValDt'].setErrors(null);
    this.reservationsDetailsForm.controls['StuNonCrmValDt'].clearValidators();
    this.reservationsDetailsForm.controls['StuNonCrmValDt'].updateValueAndValidity();

     this.reservationsDetailsForm.controls['StuMinorityType2'].setErrors(null);
    this.reservationsDetailsForm.controls['StuMinorityType2'].clearValidators();
    this.reservationsDetailsForm.controls['StuMinorityType2'].updateValueAndValidity();

    this.reservationsDetailsForm.get('StuCaste').markAsUntouched();
    this.reservationsDetailsForm.get('StuCasteCert').markAsUntouched();
    this.reservationsDetailsForm.get('StuCasteValCert').markAsUntouched();
    this.reservationsDetailsForm.get('StuNonCrmCert').markAsUntouched();
    this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();
    this.reservationsDetailsForm.get('StuInHouse').markAsUntouched();
    this.reservationsDetailsForm.get('StuMinority').markAsUntouched();
    this.reservationsDetailsForm.get('StuMinorityType').markAsUntouched();
    this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
    
      } else {
        this.reservationsDetailsForm.get('StuCaste').markAsTouched();
        this.reservationsDetailsForm.get('StuCasteCert').markAsTouched();
        this.reservationsDetailsForm.get('StuCasteValCert').markAsTouched();
        this.reservationsDetailsForm.get('StuNonCrmCert').markAsTouched();
        this.reservationsDetailsForm.get('StuNonCrmValDt').markAsTouched();
        this.reservationsDetailsForm.get('StuInHouse').markAsTouched();
        this.reservationsDetailsForm.get('StuMinority').markAsTouched();
        this.reservationsDetailsForm.get('StuMinorityType').markAsTouched();
        this.reservationsDetailsForm.get('StuMinorityType2').markAsTouched();
      }
      if (this.reservationsDetailsForm.get('StuCasteCert').value === '1') {

        this.reservationsDetailsForm.get('StuCasteValCert').markAsTouched();
        this.reservationsDetailsForm.get('StuNonCrmCert').markAsTouched();
      } 
     if (this.reservationsDetailsForm.get('StuNonCrmCert').value === '1') {
        this.reservationsDetailsForm.get('StuNonCrmValDt').markAsTouched();
      }
      if (this.reservationsDetailsForm.get('StuMinority').value === '1') {
        this.reservationsDetailsForm.get('StuMinorityType').markAsTouched();
        this.reservationsDetailsForm.get('StuMinorityType2').markAsTouched();
      }
      
      if (this.reservationsDetailsForm.get('StuMinorityType').value === '1' ||
        this.reservationsDetailsForm.get('StuMinorityType').value === '2') {
        this.reservationsDetailsForm.get('StuMinorityType2').markAsTouched();
      }
    
      if (this.reservationsDetailsForm.get('StuPhyHand').value == 1) {

        this.reservationsDetailsForm.get('StuSpecialAbledType').markAsTouched();
      } 

      if (this.reservationsDetailsForm.get('StuOrphan').value == 1) {

        this.reservationsDetailsForm.get('StuOrphanType').markAsTouched();
      } 
        return
    }else{
      this.finalsubmit();
    }
  }
  UpdScrtDetails(){
    this.spinner.show();
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CgCode'] = this.College
    payload['CoCode'] = this.Course
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if(res.status){
        this.first.emit();
        location.reload();
        this.spinner.hide();
      }
      else{
      this.spinner.hide();
      }
    } , (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getApplyData(){
    this.calledApi++;
    let payload = {}
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if(res.status){
        this.finishedApi++;
          if (this.finishedApi === this.calledApi) {
            this.spinner.hide();
          }
       this.Course = res.data[0]['Course'];
       this.College = res.data[0]['College']
      }
      else{
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  getSelectedSpecialAbledDesc(): string {
    const selectedCode = this.reservationsDetailsForm.get('StuSpecialAbledType')?.value;
    const selectedItem = this.specialAbledList.find(item => item.CdCode === selectedCode);
    return selectedItem ? selectedItem.CdDesc : '';
  }
  prepopulationContact() {
      this.spinner.show();
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId);
    this.umsService.fetchContactDetails(payload).subscribe(res => {
      // if (res.status) {
        this.spinner.hide();
        if (res.data[0].StuNationality === 'OS') {
          this.umsService.studentProgressList['StudentReservation'] = 1;
        }
      // } 
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })

  }
}

